import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Paper, Card, CardContent, makeStyles } from "@material-ui/core";
import Header from "./Header";
import ViewGoalModal from "./ViewGoalModal";
import MissingAlert from "./MissinAlert";
import MissinAlertByMaterials from "./MissinAlertByMaterials";
import externalsIndicatorsActions from "../../../redux/actions/externalsIndicators";

/* import ExportDataModal from "./ExportDataModal"; */
import Charts from "./Charts";
import ExportToExcelModal from "../ExternalsReportsAdmin/Dashboard/ExportToExcelModal";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ExternalsIndicators() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.externalsIndicators);

  useEffect(() => {
    dispatch(externalsIndicatorsActions.fetchGoals());
  }, [filters.groupID]);

  return (
    <Paper className={classes.root}>
      <Card>
        <CardContent>
          <Header />
          <MissingAlert />
          <MissinAlertByMaterials />
          <Charts />
          <ViewGoalModal />
          <ExportToExcelModal />
        </CardContent>
      </Card>
    </Paper>
  );
}
